import { createFileRoute } from "@tanstack/react-router";
import { HelpTip } from "~/components/ui/help-tip";
import { PrintingSettings } from "~/features/settings/print-agents";
import { useT } from "~/lib/i18n";

export const Route = createFileRoute("/_app/settings/printing")({ component: PrintingSettingsPage });

function PrintingSettingsPage() {
  const t = useT();
  return (
    <>
      <div className="mb-5 flex items-start gap-1">
        <p className="text-sm text-fg-2">{t("settings.pages.printing.subtitle")}</p>
        <HelpTip id="settings.printing" />
      </div>
      <PrintingSettings />
    </>
  );
}
